import { useMutation } from '@tanstack/react-query'
import axiosInstance from '@/core/api'
import type { components } from '@/schema'

type GetPresignedUrlResponse = components['schemas']['GetPresignedUrlResponse']
type GenerateUploadFileUrlDto =
	components['schemas']['GenerateUploadFileUrlDto']

export default function useMutationGetTournamentBannerUploadUrl() {
	return useMutation({
		mutationFn: async (
			data: GenerateUploadFileUrlDto,
		): Promise<GetPresignedUrlResponse> => {
			const response = await axiosInstance.post<GetPresignedUrlResponse>(
				'/file/get-tournament-banner-upload-file-url',
				data,
			)
			return response.data
		},
	})
}
